var Method;
(function (Method) {
    Method["Get"] = "GET";
    Method["Post"] = "POST";
    Method["Put"] = "PUT";
    Method["Delete"] = "DELETE";
})(Method || (Method = {}));

export { Method };
//# sourceMappingURL=types.mjs.map
